// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__IXnLy","slideDown":"content_slideDown__4LkVn","slideUp":"content_slideUp__zQBB8"};